import { render, staticRenderFns } from "./morefun.vue?vue&type=template&id=0ada00af&scoped=true&"
import script from "./morefun.vue?vue&type=script&lang=js&"
export * from "./morefun.vue?vue&type=script&lang=js&"
import style0 from "./morefun.vue?vue&type=style&index=0&id=0ada00af&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ada00af",
  null
  
)

export default component.exports